<template>
  <div>
    <register-form :can-back="true" @submit.prevent="showConfirmModal" @back="toPrivacyPolicy">
      <form-caption v-if="pageTitle" :text="pageTitle" />
      <vuex-text-form-item label="氏名" bind="name" :required="true" />
      <vuex-text-form-item label="氏名（カナ）" bind="name_kana" :required="true" />
      <vuex-email-form-item label="メールアドレス" bind="email" :required="true" />
      <vuex-text-form-item label="電話番号" bind="tel" :required="true" />
      <vuex-text-form-item label="FAX番号" bind="fax" />
      <vuex-textarea-form-item label="連絡先" bind="contact" />
    </register-form>
    <teleport to="body">
      <register-confirm-modal ref="confirmModal" @register="doRegister" />
    </teleport>
  </div>
</template>

<script>
import RegisterForm from "@/views/templates/forms/RegisterForm";
import FormCaption from '@/views/atoms/FormCaption'
import VuexTextFormItem from "@/views/molecules/formItems/VuexTextFormItem";
import VuexEmailFormItem from "@/views/molecules/formItems/VuexEmailFormItem";
import VuexTextareaFormItem from "@/views/molecules/formItems/VuexTextareaFormItem";
import RegisterConfirmModal from "@/views/molecules/modals/RegisterConfirmModal";

export default {
  name: "OwnerRegister",
  components: {
    RegisterForm,
    FormCaption,
    VuexTextFormItem,
    VuexEmailFormItem,
    VuexTextareaFormItem,
    RegisterConfirmModal,
  },
  inject: [
    '$constant',
  ],
  provide: {
    bindModule: 'guest_register_form'
  },
  computed: {
    pageTitle() {
      return this.$store.state.pageTitle;
    },
  },
  mounted() {
    this.$store.commit('guest_register_form/resetData');
    this.$store.commit('guest_register_form/clearError');
  },
  methods: {
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    doRegister() {
      this.$store.commit('guest_register_form/setManagementCompanyCode', localStorage.getItem('managementCompanyCode'));
      this.$store.dispatch('guest_register_form/register', {guestType: this.$constant.GUEST_TYPE.OWNER.code}).then(() => {
        this.$router.push({name: 'GuestRegisterComplete'});
      }).catch(reason => this.$root.failApi(reason));
    },
    toPrivacyPolicy() {
      this.$router.push({name: 'PrivacyPolicyAgreement'});
    },
  }
}
</script>
